var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('computed-status-badge',{attrs:{"status-list":_vm.allTransactionStatus,"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }